import { render, staticRenderFns } from "./SchoolSplitExport.vue?vue&type=template&id=0cfe6b58&"
import script from "./SchoolSplitExport.vue?vue&type=script&lang=js&"
export * from "./SchoolSplitExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports